// AUTO-GENERATED from docs/TECHNICAL_PRD.md — CID Agent PWA API layer
// Module: Team & Career (downline tree, recruit counts, override rollup, TL promotion roadmap, GCI tier ladder)
// Every list (collection GET) takes params { page, limit, ...filters }.
import client from './client';

/**
 * GET /api/agent/team/tree [LIST · paginated]
 * My downline as a nested tree, root = me, limited to Gen 1-4, each node annotated with generation, management_rank, gci_tier and GCI so the app can render the org chart the spec asks for.
 * @disposition ADAPT_SCOPE · maps to GET /hierarchy/agent/:id/team (hierarchy.service.getAgentTeam)
 */
export const listTeamTree = (params = {}) => client.get(`/api/agent/team/tree`, { params });

/**
 * GET /api/agent/team/recruits [LIST · paginated]
 * My recruit-count headline numbers (direct active recruits, post-April-2026 recruits) plus which override rule-set applies to me — feeds the recruiting/generation-unlock UI.
 * @disposition ADAPT_SCOPE · maps to GET /agents/:id (agent.service.getAgentById)
 */
export const listTeamRecruits = (params = {}) => client.get(`/api/agent/team/recruits`, { params });

/**
 * GET /api/agent/team/overrides [LIST · paginated]
 * My override earnings rolled up from the team: total override income and a per-downline-seller / per-generation breakdown, so I can see which recruits and which generations pay me.
 * @disposition BUILD_NEW · maps to NEW (aggregation over sale_commissions produced by commission.service)
 */
export const listTeamOverrides = (params = {}) => client.get(`/api/agent/team/overrides`, { params });

/**
 * GET /api/agent/career/roadmap [LIST · paginated]
 * My TL-promotion challenge: current 3-month window, month-by-month GCI vs the RM200k target, min-recruits gate, and whether the window is met — the promotion progress screen.
 * @disposition ADAPT_SCOPE · maps to GET /agents/:id/promotion-roadmap (promotion.service.getPromotionRoadmap)
 */
export const listCareerRoadmap = (params = {}) => client.get(`/api/agent/career/roadmap`, { params });

/**
 * POST /api/agent/career/start-challenge
 * Agent-initiated start of a TL promotion challenge (OPEN — see questions; a challenge is already auto-created at agent creation and on demotion-to-AGENT, so this is usually a no-op/duplicate-guard).
 * @disposition ADAPT_SCOPE · maps to POST /agents/:id/start-challenge (promotion.service.startChallenge)
 */
export const createCareerStartChallenge = (data = {}) => client.post(`/api/agent/career/start-challenge`, data);

/**
 * GET /api/agent/career/tier-ladder [LIST · paginated]
 * My GCI-tier ladder: every tier 60->90, my current tier, my lifetime/current-year GCI position, and exactly how much more GCI unlocks the next tier (incl. the 85% lifetime floor and the in-year 87/90 step-ups that reset annually). NOT the admin simulator (that writes to the agent).
 * @disposition BUILD_NEW · maps to NEW (derive from constants GCI_TIER_THRESHOLDS + GCI_TIER_85_PLUS + my agents-row GCI)
 */
export const listCareerTierLadder = (params = {}) => client.get(`/api/agent/career/tier-ladder`, { params });

// Directory search of active agents — used to add a co-agent to a sale's commission split.
export const listAgentsLookup = (params = {}) => client.get(`/api/agent/agents/lookup`, { params });
